import { useState, useEffect } from "react";
import moment from "moment";

import "moment/locale/pt-br";

function Faq() {
  const [opt, setOpt] = useState(0);
  const [opt2, setOpt2] = useState(0);

  const love = [
    "sim",
    "claro que sim",
    "sem dúvida alguma que sim",
    "sim, quantas vez precisar",
    "mais uma vez, sim",
    "sempre sim",
    "sim sim sim!",
    "com certeza",
    "absolutamente sim",
  ];

  const things = [
    "seu sorriso",
    "seu jeito de falar",
    "sua risada",
    "seu olhar",
    "sua inteligência",
    "sua bondade",
    "sua força",
    "seu jeito de me amar",
    "sua paciência",
    "seu cabelo",
    "seu jeito de ser",
    "sua presença",
    "sua companhia",
    "seu carinho",
    "seu amor",
    "sua essência",
    "sua energia",
    "seu jeito de me fazer rir",
    "seu cheiro",
    "sua pele",
    "seu abraço",
    "seu beijo",
    "seu calor",
    "sua voz",
    "seu jeito de me olhar",
    "sua alma",
    "seu jeito de me tocar",
    "sua comida",
    "seu jeito de dançar",
    "sua maneira de ver o mundo",
    "sua parceria",
    "seu apoio",
    "sua compreensão",
    "sua amizade",
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setOpt((p) => (p < love.length - 1 ? p + 1 : 0));
    }, 3330);

    return () => clearInterval(interval);
  }, [love.length]);

  useEffect(() => {
    const interval = setInterval(() => {
      setOpt2((p) => (p < things.length - 1 ? p + 1 : 0));
    }, 705);

    return () => clearInterval(interval);
  }, [things.length]);

  return (
    <div
      id="faq"
      className="d-flex align-items-center justify-content-center py-5"
    >
      <div className="container py-5">
        <h1>FAQ</h1>
        <br />
        <h3>Meu lugar preferido no mundo?</h3>
        <h4>Qualquer um, desde que seja ao seu lado</h4>
        <hr />
        <h3>E desde quando esse é o meu lugar preferido?</h3>
        <h4>
          Desde que conheci você e descobri a pessoa <u>incrível</u> que você é
        </h4>
        <hr />
        <h3>Há quanto tempo estamos namorando?</h3>
        <h4>
          {moment("2024-12-23").from(moment())}{" "}
          <small>
            (são {moment(moment()).diff("2024-11-23", "days")} dias /
            aproximadamente {moment(moment()).diff("2024-11-23 11:30", "hours")}{" "}
            horas){" "}
          </small>
        </h4>
        <hr />
        <h3>Temos algum lugarzinho especial?</h3>
        <h4>
          Temos, todos os lugares se tornam especial com você, mas, vou guardar
          pra sempre esse aqui, ó:{" "}
          <u>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://maps.app.goo.gl/rs83VJyzTdEpqQWy8"
            >
              23°10′18″ S, 44°41′58″ W
            </a>
          </u>
        </h4>
        <hr />
        <h3>Se eu te amo?</h3>
        <h4>{love[opt]}</h4>
        <hr />
        <h3>E o que eu mais amo em você?</h3>
        <h4>
          {things[opt2]}
          <br />
          <small>(simplesmente tudo)</small>
        </h4>
        <hr />
        <h3>O que eu penso para o futuro?</h3>
        <h4>
          Quero caminhar ao seu lado, construindo uma vida juntos, enfrentando
          desafios, celebrando conquistas e criando memórias
        </h4>
      </div>
    </div>
  );
}

export default Faq;
